export const COMPANY_INFORMATION_CONSTANTS = {
  CNPJ_LENGTH: 14,
  MIN_COMPANY_NAME_LENGTH: 2,
  NON_PROFESSIONAL_IDS: ["11830", "11831", "11842"],
  SPECIAL_ORIGIN_ID: "12229",
  PLACEHOLDERS: {
    CNPJ: "Qual o CNPJ de onde você trabalha?",
    COMPANY_NAME_FOUND: "Nome da empresa"
  },
  ERROR_MESSAGES: {
    INVALID_CNPJ: "CNPJ inválido",
    INCOMPLETE_CNPJ: "Esse CNPJ está incompleto",
    INCORRECT_NAME: "Nome incorreto",
    MAX_CHARACTERS: "Limite de caracteres alcançado"
  }
} as const;